import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { ref } from 'vue'
import NcDialog from '@nextcloud/vue/components/NcDialog'
import NcTextField from '@nextcloud/vue/components/NcTextField'

// FIXME use real types from @nextcloud/vue
type ClassType = string | Record<string, boolean | undefined>
type VueClassType = ClassType | ClassType[] | VueClassType[]
type NcDialogButtonProps = {
	label: string
	callback?: () => unknown | false | Promise<unknown | false>
	disabled?: boolean
	icon?: string
	type?: 'submit' | 'reset' | 'button'
	variant?: 'primary' | 'secondary' | 'tertiary' | 'tertiary-no-background' | 'tertiary-on-primary' | 'error' | 'warning' | 'success'
}
type NcDialogProps = {
	name: string
	buttons?: NcDialogButtonProps[]
	container?: string
	message?: string
	size?: 'small' | 'normal' | 'large' | 'full'
	additionalTrapElements?: Array<string | HTMLElement>
	closeOnClickOutside?: boolean
	contentClasses?: VueClassType
	dialogClasses?: VueClassType
	isForm?: boolean
	navigationAriaLabel?: string
	navigationAriaLabelledby?: string
	navigationClasses?: VueClassType
	noClose?: boolean
	outTransition?: boolean
}
type NcInputFieldProps = {
	disabled?: boolean
	error?: boolean
	id?: string
	value?: string
	label?: string
	labelOutside?: boolean
	placeholder?: string
	showTrailingButton?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmDialog',
  props: {
    name: {},
    buttons: {},
    container: {},
    message: {},
    size: {},
    additionalTrapElements: {},
    closeOnClickOutside: { type: Boolean },
    contentClasses: {},
    dialogClasses: {},
    isForm: { type: Boolean },
    navigationAriaLabel: {},
    navigationAriaLabelledby: {},
    navigationClasses: {},
    noClose: { type: Boolean },
    outTransition: { type: Boolean },
    inputProps: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const inputValue = ref(props.inputProps?.value ?? '')

/**
 * Emit result, if any (for spawnDialog callback)
 *
 * @param result callback result
 */
function onClosing(result: unknown) {
	if (props.isForm && props.inputProps) {
		onSubmit(inputValue.value)
	} else {
		emit('close', result)
	}
}

/**
 * Emit submitted new input value (for spawnDialog callback)
 *
 * @param value new value
 */
function onSubmit(value: string) {
	emit('close', value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NcDialog), {
    name: __props.name,
    message: __props.message,
    container: __props.container,
    size: __props.size,
    buttons: __props.buttons,
    onClosing: onClosing
  }, {
    default: _withCtx(() => [
      (__props.isForm && __props.inputProps)
        ? (_openBlock(), _createBlock(_unref(NcTextField), {
            key: 0,
            modelValue: inputValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
            label: __props.inputProps.label,
            disabled: __props.inputProps.disabled,
            "show-trailing-button": __props.inputProps.showTrailingButton,
            onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (onSubmit(inputValue.value)), ["enter"]))
          }, null, 8, ["modelValue", "label", "disabled", "show-trailing-button"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["name", "message", "container", "size", "buttons"]))
}
}

})